// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3U8wD","emails":"CreateEditClinics_emails__OJRMf","emailTagLabel":"CreateEditClinics_emailTagLabel__3vw8N"};